import Header from './Header';

export type {IHeaderProps} from './Header';
export default Header;
